interface State {
  resize: number
  scroll: number
}

export default {
  namespaced: true,
  state: {
    resize: Date.now(),
    scroll: 0,
    trigger: {}
  },
  getters: {
    getScrollTop (state:{scroll:number}) {
      return state.scroll
    }
  },
  mutations: {}
}
